(() => {
  window.TAN_QUOTE_CURRENCY_CONFIG = {
    baseCurrency: 'EUR',
    asOf: '2026-08-10',
    source: 'European Central Bank reference rates',
    currencies: {
      EUR: { rate: 1, roundTo: 10 },
      USD: { rate: 1.1555, roundTo: 10 },
      JPY: { rate: 183.31, roundTo: 1000 },
      CZK: { rate: 24.252, roundTo: 100 },
      DKK: { rate: 7.4758, roundTo: 50 },
      GBP: { rate: 0.85565, roundTo: 10 },
      HUF: { rate: 363.65, roundTo: 1000 },
      PLN: { rate: 4.2993, roundTo: 25 },
      RON: { rate: 5.2433, roundTo: 10 },
      SEK: { rate: 10.9655, roundTo: 50 },
      CHF: { rate: 0.934, roundTo: 10 },
      ISK: { rate: 142.2, roundTo: 500 },
      NOK: { rate: 10.986, roundTo: 50 },
      TRY: { rate: 55.1116, roundTo: 50 },
      AUD: { rate: 1.6359, roundTo: 10 },
      BRL: { rate: 5.8764, roundTo: 25 },
      CAD: { rate: 1.6108, roundTo: 25 },
      CNY: { rate: 7.7931, roundTo: 50 },
      HKD: { rate: 9.0653, roundTo: 50 },
      IDR: { rate: 20521.74, roundTo: 50000 },
      ILS: { rate: 3.4671, roundTo: 10 },
      INR: { rate: 110.1228, roundTo: 100 },
      KRW: { rate: 1636.9, roundTo: 10000 },
      MXN: { rate: 19.8182, roundTo: 50 },
      MYR: { rate: 4.7266, roundTo: 10 },
      NZD: { rate: 1.9613, roundTo: 10 },
      PHP: { rate: 70.197, roundTo: 100 },
      SGD: { rate: 1.4785, roundTo: 10 },
      THB: { rate: 38.146, roundTo: 50 },
      ZAR: { rate: 18.6928, roundTo: 50 },
      BGN: { rate: 1.95583, roundTo: 10 },
      AED: { rate: 4.244, roundTo: 25 },
      SAR: { rate: 4.333, roundTo: 25 },
      QAR: { rate: 4.205, roundTo: 25 },
    },
  };
})();
